const LOGO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_daab-recruit/artifacts/kveh0gcx_file_0000000029048211809fc80c6002540d.webp";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#e4e4e7] px-6 md:px-12 pt-14 pb-28 md:pb-14">
    <div className="max-w-[1600px] mx-auto">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div className="max-w-sm">
          <div className="mb-6" data-testid="footer-logo">
            <img src={LOGO} alt="DAAB Consulting Recruitment Services" className="h-16 md:h-20 w-auto object-contain" />
          </div>
          <p className="font-body text-[#52525b] leading-relaxed">
            Precise search and honest representation for companies and workers building
            what's next — across warehouses, construction, hospitality and the road.
          </p>
        </div>

        <div className="flex flex-wrap gap-x-14 gap-y-8 font-body text-sm">
          <div className="flex flex-col gap-3">
            <span className="text-[#a1a1aa] uppercase tracking-[0.2em] text-xs mb-1">Navigate</span>
            <a href="#for-employers" className="text-[#52525b] hover:text-[#0a0a0a]">Employers</a>
            <a href="#for-candidates" className="text-[#52525b] hover:text-[#0a0a0a]">Candidates</a>
            <a href="#roles" className="text-[#52525b] hover:text-[#0a0a0a]">Vacancies</a>
            <a href="#partners" className="text-[#52525b] hover:text-[#0a0a0a]">Partners</a>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-[#a1a1aa] uppercase tracking-[0.2em] text-xs mb-1">Office</span>
            <span className="text-[#52525b] max-w-[220px] leading-relaxed" data-testid="footer-address">
              Passeig de Gràcia, 95
              <br />
              08008 Barcelona, Spain
            </span>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-[#a1a1aa] uppercase tracking-[0.2em] text-xs mb-1">Reach us</span>
            <a href="tel:+34663118471" className="text-[#52525b] hover:text-[#0a0a0a]" data-testid="footer-phone">
              +34 663 118 471
            </a>
            <a href="https://wa.me/34663118471" target="_blank" rel="noopener noreferrer" className="text-[#52525b] hover:text-[#25D366]" data-testid="footer-whatsapp">
              WhatsApp: +34 663 118 471
            </a>
            <a href="mailto:partners@daabconsulting.com" className="text-[#52525b] hover:text-[#0a0a0a]">
              partners@daabconsulting.com
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-[#e4e4e7] flex flex-col md:flex-row md:items-center gap-4 font-body text-xs text-[#a1a1aa]">
        <a href="/admin" data-testid="footer-admin-link" className="inline-flex items-center gap-2 border border-[#e4e4e7] text-[#52525b] hover:border-[#ff3b30] hover:text-[#ff3b30] px-4 py-2 uppercase tracking-wide transition-colors w-max">
          Admin Login
        </a>
        <span className="md:ml-auto">© {new Date().getFullYear()} Daab Recruitment. All rights reserved.</span>
        <span className="font-accent italic text-sm">Talent, Connection, Success.</span>
      </div>
    </div>
  </footer>
);
